export default "__VITE_ASSET__oTZrUA0G__"